import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const slackTemplate = {
	id: 'slack',
	guid: '05a68e8f-d319-402c-ae61-3f3a8a4ec4bb',
	name: 'Slack',
	category: TEMPLATE_CATEGORIES.COMMUNICATION,
	popularity: 'Popular',
	color: '#4a154b',
	icon: 'mdi-slack',
	description: 'Team communication platform for notifications and workflow automation.',
	features: ['OAuth2 Auth', 'Message Sending', 'Channel Management', 'Bot Integration'],
	endpoints: [
		{
			name: 'Send a Message - Failed Connector Service Message',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a failed Connector Service message',
			cassieObjectID: -1,
			incrementField: 'FailureID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ServiceName', filter: '' },
				{ name: 'FailureID', filter: '' },
				{ name: 'OriginalResponseCode', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "Connector Service System [PLACEHOLDER_SERVICENAME] has a failed message with ID [PLACEHOLDER_FAILUREID].  The HTTP response code is [PLACEHOLDER_ORIGINALRESPONSECODE]." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - Failed Submissions',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a failed Syrenis submission',
			cassieObjectID: -2,
			incrementField: 'SubmissionID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ErrorNumber', filter: '' },
				{ name: 'ErrorMessage', filter: '' },
				{ name: 'SubmissionID', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "The Syrenis API returned the following error details, [PLACEHOLDER_ERRORNUMBER], [PLACEHOLDER_ERRORMESSAGE]." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Send a Message - New Cookie(s) Found',
			url: 'https://slack.com/api/chat.postMessage',
			method: 'POST',
			description: 'Send a message to a Slack Channel advising of a new Cookie found following a recurring scan',
			cassieObjectID: -8,
			incrementField: 'ScanResultDateTime',
			resetIncrementValue: false,
			fields: [
				{ name: 'ScanID', filter: '' },
				{ name: 'CookieName', filter: '' },
				{ name: 'PreviousCoId', filter: '' }
			],
			requestBody: '{ "channel": "Slack_Channel_ID", "text": "The current scan no. [PLACEHOLDER_SCANID] found Cookie with name \'[PLACEHOLDER_COOKIENAME]\' which wasn\'t present in scan no. [PLACEHOLDER_PREVIOUSSCANID].  Please investigate.." }',
			headers: [
				{ Name: 'Content-Type', value: 'application/json; charset=utf-8' }
			],
			successResponses: [{ code: 200, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://slack.com/api',
		authenticationUrl: 'https://slack.com/oauth/v2/authorize',
		authenticationTypeId: AUTH_TYPES.OAUTH2_CLIENT_CREDENTIALS,
		frequencyInSeconds: 0,
		auth2Scope: 'chat:write,channels:read,users:read',
		notes: 'Slack team communication integration for sending notifications and managing team interactions.'
	}
}
